import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  getStringHashCode26igk1bx568vk as getStringHashCode,
  equals2au1ep9vhcato as equals,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SecretClass;
function Secret() {
  if (SecretClass === VOID) {
    class $ {
      constructor(id, description, createdTimestamp, lastUsedTimestamp) {
        this.p2d_1 = id;
        this.q2d_1 = description;
        this.r2d_1 = createdTimestamp;
        this.s2d_1 = lastUsedTimestamp;
      }
      toString() {
        return 'Secret(id=' + this.p2d_1.toString() + ', description=' + this.q2d_1 + ', createdTimestamp=' + this.r2d_1.toString() + ', lastUsedTimestamp=' + toString(this.s2d_1) + ')';
      }
      hashCode() {
        var result = this.p2d_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.q2d_1) | 0;
        result = imul(result, 31) + this.r2d_1.hashCode() | 0;
        result = imul(result, 31) + (this.s2d_1 == null ? 0 : this.s2d_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Secret()))
          return false;
        if (!this.p2d_1.equals(other.p2d_1))
          return false;
        if (!(this.q2d_1 === other.q2d_1))
          return false;
        if (!this.r2d_1.equals(other.r2d_1))
          return false;
        if (!equals(this.s2d_1, other.s2d_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Secret');
    SecretClass = $;
  }
  return SecretClass;
}
//region block: exports
export {
  Secret as Secret2t4auo9luo6wh,
};
//endregion

//# sourceMappingURL=Secret.mjs.map
